import {Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Model} from '../../model/model';
import {DatePipe} from '@angular/common';
import {MatTable} from '@angular/material/table';
import {UsersService} from 'src/app/services/users.service';

@Component({
  selector: 'aw-general-item-detail-dialog',
  templateUrl: './general-item-detail-dialog.component.html',
  styleUrls: ['./general-item-detail-dialog.component.scss']
})
export class GeneralItemDetailDialogComponent implements OnInit {
  dataSource!: { field: string, value: any }[];
  @Input() public inputData?: Model;
  @Input() public disableCloseButton?: boolean;
  @ViewChild('table') table: MatTable<{ field: string, value: any }>;

  expandUrl = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: Model,
    private datePipe: DatePipe,
    private userService: UsersService) {
  }


  excludedFields = [
    "id",
    "cognitoId",
    "bucketId",
    "role",
    "enabled",
    "createdBy",
    "testbed",
    "contractReferent",
    "storage"
  ];

  ngOnInit(): void {
    if (this.inputData)
      this.data = this.inputData;

    this.dataSource = [];
    // eslint-disable-next-line prefer-const
    for (let [key, value] of Object.entries(this.data)) {
      if (value && !this.excludedFields.includes(('' + key))) {

        if (typeof value === 'object')
          continue;
        if (('' + value).match(/[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}\:[0-9]{2}\:[0-9]{2}\.[0-9]{3}Z/)) {
          const d = this.datePipe.transform(value, 'dd/MM/yyyy HH:mm');
          this.dataSource.push({ field: key, value: d });
        } else {
          if (('' + key).toLowerCase().includes('space'))
            value = value + 'MB';
          if (('' + key).toLowerCase() === 'thirdPartyContract')
            value = '€ ' + value;
          this.dataSource.push({ field: key, value: value });
        }
        if (key === 'showMore') {
          this.expandUrl = value;
          console.log(this.expandUrl);
          this.dataSource.pop();
        }
      }
    }
  }

  openExpandUrl() {
    if (this.expandUrl) {
      window.open(this.expandUrl, '_blank');
    }
  }

}
